import {Tab} from '@components/ui/tabs/tab';
import {
  APP_REQUESTS_COMPLETED,
  APP_REQUESTS_IN_PROGRESS,
  APP_REQUESTS_IN_REVIEW,
  APP_REQUESTS_NEW
} from '../config/app-urls';

export class RequestTabs {
  public static readonly New: Tab = {
    id: 'new',
    title: 'New',
    appRoute: APP_REQUESTS_NEW
  };
  public static readonly InProgress: Tab = {
    id: 'in-progress',
    title: 'In Progress',
    appRoute: APP_REQUESTS_IN_PROGRESS
  };
  public static readonly InReview: Tab = {
    id: 'in-review',
    title: 'In Review',
    appRoute: APP_REQUESTS_IN_REVIEW
  };
  public static readonly Completed: Tab = {
    id: 'completed',
    title: 'Completed',
    appRoute: APP_REQUESTS_COMPLETED
  };
}
